const IN_PERSON = 'in_person';
const PHONE_CALL = 'phone_call';
const EVALUATION = 'evaluation';

export const MEETING_KIND_OPTIONS = [
  {
    id: IN_PERSON,
    value: IN_PERSON,
    name: 'Un rendez-vous à l\'agence',
  },
  {
    id: PHONE_CALL,
    value: PHONE_CALL,
    name: 'Un rendez-vous téléphonique',
  },
  {
    id: EVALUATION,
    value: EVALUATION,
    name: 'Une évaluation de départ',
  },
];

export const MEETING_KIND_ACTION = {
  [IN_PERSON]: 'venue',
  [PHONE_CALL]: 'appel',
  [EVALUATION]: 'évaluation de départ',
};

export const meetingKindAction = (kind) => MEETING_KIND_ACTION[kind] || 'venue';

export const MEETING_KIND_LABELS = {
  [IN_PERSON]: 'Rendez-vous en agence',
  [PHONE_CALL]: 'Rendez-vous téléphonique',
  [EVALUATION]: 'Évaluation de départ',
};

export const MEETING_DEFAULT_KIND = IN_PERSON;
